/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.36.0
 * source: google/protobuf/any.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
export namespace google.protobuf {
    export class Any extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            typeUrl?: string;
            value?: Uint8Array;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("typeUrl" in data && data.typeUrl != undefined) {
                    this.typeUrl = data.typeUrl;
                }
                if ("value" in data && data.value != undefined) {
                    this.value = data.value;
                }
            }
        }
        get typeUrl() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set typeUrl(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get value() {
            return pb_1.Message.getFieldWithDefault(this, 2, new Uint8Array(0)) as Uint8Array;
        }
        set value(value: Uint8Array) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            typeUrl?: string;
            value?: Uint8Array;
        }): Any {
            const message = new Any({});
            if (data.typeUrl != null) {
                message.typeUrl = data.typeUrl;
            }
            if (data.value != null) {
                message.value = data.value;
            }
            return message;
        }
        toObject() {
            const data: {
                typeUrl?: string;
                value?: Uint8Array;
            } = {};
            if (this.typeUrl != null) {
                data.typeUrl = this.typeUrl;
            }
            if (this.value != null) {
                data.value = this.value;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.typeUrl.length)
                writer.writeString(1, this.typeUrl);
            if (this.value.length)
                writer.writeBytes(2, this.value);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Any {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Any();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.typeUrl = reader.readString();
                        break;
                    case 2:
                        message.value = reader.readBytes();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Any {
            return Any.deserialize(bytes);
        }
    }
}
